"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListingPhotoKind = void 0;
var ListingPhotoKind;
exports.ListingPhotoKind = ListingPhotoKind;

(function (ListingPhotoKind) {
  ListingPhotoKind["Large"] = "large";
  ListingPhotoKind["SearchPagePreview"] = "search-page-preview";
})(ListingPhotoKind || (exports.ListingPhotoKind = ListingPhotoKind = {}));